import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 22H2V20H7V22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15 22H9V20H15V22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22H17V20H22V22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.7773 5.5C17.0352 5.5 18.0554 6.51956 18.0557 7.77734C18.0557 9.03533 17.0353 10.0557 15.7773 10.0557C14.5196 10.0554 13.5 9.03518 13.5 7.77734C13.5002 6.51971 14.5197 5.50023 15.7773 5.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 18H2V2H22V18ZM4 11.2432L8.29395 7.7041L18.3584 16H20V4H4V11.2432Z"}}]};

const ImageCarouselFilled = Vue.extend<IconProps>({
  name: 'ImageCarouselFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'image-carousel-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ImageCarouselFilled;
